import { useCallback, useEffect, useState } from "react";
import api, { errorText } from "./api";

export const POLL_MS = 45000;

// One dashboard endpoint: loaded on mount, then every 45 s while the browser tab is visible (only the open tab's).
// poll=false: loaded only on mount / when the path changes / on reload (the Logs tile: every read is audited).
export function useDash(path, { poll = true } = {}) {
  const [state, setState] = useState({ data: null, error: null, loading: true });
  const load = useCallback(async () => {
    try {
      const { data } = await api.get(path);
      setState({ data, error: null, loading: false });
    } catch (e) {
      setState((s) => ({ ...s, error: errorText(e, "Could not load this."), loading: false }));
    }
  }, [path]);
  useEffect(() => {
    load();
    if (!poll) return undefined;
    const t = setInterval(() => document.visibilityState === "visible" && load(), POLL_MS);
    return () => clearInterval(t);
  }, [load, poll]);
  return { ...state, reload: load };
}

export { usd } from "./money";

export const money = (v, currency = "USD") =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: currency || "USD" }).format(Number(v || 0));

export const ago = (iso) => {
  if (!iso) return "never";
  const s = Math.max(0, Math.round((Date.now() - new Date(iso).getTime()) / 1000));
  if (s < 60) return `${s}s ago`;
  if (s < 3600) return `${Math.round(s / 60)} min ago`;
  if (s < 86400) return `${Math.round(s / 3600)} h ago`;
  return `${Math.round(s / 86400)} d ago`;
};

export const duration = (seconds) => {
  const s = Number(seconds || 0);
  const d = Math.floor(s / 86400);
  const h = Math.floor((s % 86400) / 3600);
  const m = Math.floor((s % 3600) / 60);
  return d ? `${d}d ${h}h` : h ? `${h}h ${m}m` : `${m}m`;
};

export const clock = (iso) => (iso ? new Date(iso).toLocaleString([], { month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" }) : "");
